import CodeSplitEnvWrapper from 'pricing-pages-ui/components/common/env/CodeSplitEnvWrapper';
import { useSelector } from 'react-redux';
import { STARTER } from 'self-service-api/constants/ProductLevels';
import SuiteProductLevelIdentifiersMap from '../../constants/merchCards/SuiteProductLevelIdentifiersMap';
import { SCREENS } from '../../constants/tracking/Screens';
import { APP, BREEZE_INTELLIGENCE_STARTER_PLATFORM_CARD } from '../../constants/tracking/TrackingSources';
import { useDisplayedCurrencyCode } from '../../hooks/useCurrencies';
import { skuIdHasBundledProductsSelector, upgradeProductSelector } from '../../selectors/ProductsSelectors';
import { commonPurchaseMotionsSelector } from '../../selectors/PurchaseMotionSelectors';
import { useQueryParamTerm } from '../../utils/urls/appQueryParamUtils';
import LoadingMerchCardCTAs from '../merch-card/LoadingMerchCardCTAs';
import { jsx as _jsx } from "react/jsx-runtime";
const BreezeCardCTAsContainer = props => {
  const {
    sourceId,
    hubsSignupProductOverride,
    trackingSource = BREEZE_INTELLIGENCE_STARTER_PLATFORM_CARD,
    productConfigurations,
    returnFirstCTAOnly,
    screen,
    purchaseMotionsOverride
  } = props;
  const {
    queryParamTerm
  } = useQueryParamTerm();
  const skuIds = productConfigurations.map(({
    skuId
  }) => skuId);
  const commonPurchaseMotions = useSelector(state => {
    if (purchaseMotionsOverride && purchaseMotionsOverride.length > 0) {
      return purchaseMotionsOverride;
    }
    return commonPurchaseMotionsSelector(state, {
      skuIds,
      location: 'MERCH_CARD',
      queryParamTerm
    });
  });
  const upgradeProduct = useSelector(state => upgradeProductSelector(state, {
    skuIds
  }));
  const upgradeData = {
    app: APP,
    screen: screen || SCREENS.BREEZE_INTELLIGENCE,
    uniqueId: `${trackingSource}-${STARTER.toLowerCase()}`,
    upgradeProduct
  };
  const activeCurrency = useDisplayedCurrencyCode();
  const hasBundleSuite = useSelector(state => productConfigurations.find(config => skuIdHasBundledProductsSelector(state, {
    skuId: config.skuId
  })));
  const nonMerchandiseIdIdentifier = hasBundleSuite ? '' : SuiteProductLevelIdentifiersMap[STARTER];
  const purchaseMotionsToUse = returnFirstCTAOnly && commonPurchaseMotions.length ? [commonPurchaseMotions[0]] : commonPurchaseMotions;
  const pmbwProps = {
    className: 'm-left-0',
    currencyCode: activeCurrency,
    level: 1,
    trackingSource,
    nonMerchandiseIdIdentifier,
    productConfigurations,
    purchaseMotions: purchaseMotionsToUse,
    queryParamTerm,
    screen: SCREENS.BREEZE_INTELLIGENCE,
    skipInterstitialPage: true,
    upgradeData,
    use: 'primary',
    purchaseMotionLocation: 'MERCH_CARD',
    block: true
  };
  const publicPMBProps = {
    dtbSource: `pricing-page|breeze-intelligence|starter`,
    hubsSignupProductOverride,
    productConfigurations,
    purchaseMotion: purchaseMotionsToUse[0],
    queryParamTerm,
    sourceId: sourceId || 'pricing-hero',
    trackingSource,
    use: 'primary'
  };
  return /*#__PURE__*/_jsx(CodeSplitEnvWrapper, {
    authedComponentLoader: () => import( /* webpackChunkName: "authed-chunk" */`pricing-pages-ui/components/common/purchaseMotions/PurchaseMotionButtonWrapper`),
    publicComponentLoader: () => import( /* webpackChunkName: "public-chunk" */`pricing-pages-ui/features/purchaseMotions/components/PublicPurchaseMotionButton`),
    authedComponentProps: pmbwProps,
    publicComponentProps: publicPMBProps,
    publicComponentLoadingState: LoadingMerchCardCTAs,
    authedComponentLoadingState: LoadingMerchCardCTAs
  });
};
export default BreezeCardCTAsContainer;